<ng-container *ngIf="isReady">
  <idp-vacation-widget
    (expandEmit)="expandEmit.emit($event)"
    (openModalEmit)="openModalEvent = $event"
    (formSubmitted)="formSubmitted()"
    [airportSelected]="
      destinationType === 'From' ? originAirport : destinationAirport
    "
    [viewSearchOptionExpanded]="viewSearchOptionExpanded"
    [destinationType]="destinationType"
    [closeModal]="openModalEvent"
    [resetErrors]="resetErrors"
    [vacationWidgetForm]="bookingVacationFacadeService.vacationWidgetForm"
    [content]="
      (bookingVacationFacadeService.vacationWidgetContent$ | ngrxPush) ||
      emptyVacationContent
    "
    (analyticsEvent)="analyticsService.populateAnalyticsData($event)"
  ></idp-vacation-widget>
  <idp-airport-dropdown
    *ngIf="isSelected"
    [openModal]="openModalEvent"
    [selectedValue]="
      destinationType === 'From'
        ? { code: originAirport.code, name: originAirport.code }
        : { code: destinationAirport.code, name: destinationAirport.code }
    "
    [airportModalContent]="airportModalContent"
    (airportSelected)="onAirportSelected($event)"
    (searchValueEmit)="searchValue($event)"
    (closeModal)="openModalEvent = false"
  ></idp-airport-dropdown>
</ng-container>

<div
  *ngIf="!isReady && !showAlert"
  id="mach-core-booking-vacation-loader"
  class="flex flex-col items-center gap-16 p-16"
>
  <div class="component-loader"></div>
</div>

<div
  [ngClass]="{
    hidden: !showAlert
  }"
  id="mach-core-booking-vacation-alert"
  class="flex flex-col gap-8"
>
  <section
    [id]="bookingVacationFacadeService.adapter.messageBannerId"
    class="message-banner"
  ></section>
</div>
